import React, { useContext } from "react";
import { useFormik } from "formik";
import { createOrganization } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import { OrganizationContext } from "../../contexts/OrganizationContextProvider";
import { organizationValidationSchema } from "../../utils/validations";
import { ProjectContext } from "../../contexts/ProjectContextProvider";
import ModalUI from "../ui/ModalUI";
import ShortTextInput from "../Inputs/ShortTextInput";
import TextAreaInput from "../Inputs/TextAreaInput";
import CustomButton from "../CustomButton";

function CreateAnOrganization({ show, handleClose }) {
  const { refresh } = useContext(OrganizationContext);
  const { refresh: refreshProjects } = useContext(ProjectContext);

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
    },
    validationSchema: organizationValidationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      // values = {name: "Organization Name", description: "Organization Description"}

      createOrganization(values)
        .then((response) => {
          if( response.status === 201) 
          {showToast("Organization added successfully.", "success");
          refresh();
          refreshProjects();
          resetForm();
          handleClose();
        }
        })
        .catch(() => {
          showToast(
            "Failed to create organization. Please try again.",
            "error"
          );
        })
        .finally(() => setSubmitting(false));
    },
    enableReinitialize: true,
  });

  return (
    <ModalUI show={show} handleClose={handleClose} title="Create New Organization">
      <form onSubmit={formik.handleSubmit}>
        <ShortTextInput
          id="name"
          label="Name"
          name="name"
          placeholder={`Enter Organization Name`}
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.touched.name && formik.errors.name}
        />
        <TextAreaInput
          id="description"
          label="Description"
          name="description"
          placeholder={`Enter Organization Description`}
          value={formik.values.description}
          onChange={formik.handleChange}
          error={formik.touched.description && formik.errors.description}
        />
        <div className="d-flex justify-content-center p-3">
          <CustomButton disabled={formik.isSubmitting} type="submit">
            {formik.isSubmitting ? "Processing..." : "Create"}
          </CustomButton>
        </div>
      </form>
    </ModalUI>
  );
}

export default CreateAnOrganization;